import { first, mergeMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService, DigestService, TenantService } from '../services';

@Component({
    selector: 'thin-signup-complete',
    template: `
        <mat-card>
            <spinner *ngIf="noTouching"></spinner>
            <mat-card-content *ngIf="!noTouching">
                Your signup is complete and your briefings will shortly be on the way!
            </mat-card-content>
        </mat-card>
    `
})
export class ThinSignupCompleteComponent implements OnInit {
    noTouching: boolean;
    
    constructor(private route: ActivatedRoute, 
                private router: Router,
                private snackBar: MatSnackBar,
                private digestService: DigestService,
                private tenantService: TenantService,
                private userService: UserService) {}
    
    ngOnInit(): void {
        if (this.route.snapshot.queryParams.invitationCode) {
            this.noTouching = true;
            forkJoin(
                this.tenantService.getUnauthTenantInfo(),
                this.userService.canActivate(null, this.route.snapshot.queryParams.invitationCode)
            ).pipe(first())
            .subscribe(([tenant, activationResults]) => {
                if (activationResults.canActivate) {
                    this.userService.activateUser(activationResults.user)
                    .pipe(
                        mergeMap(() => {
                            const createEnabled = tenant.settings.noInitialDigest === 'true' ? undefined : true;
                            return this.digestService.getDigestConfigurationsForUser(activationResults.user.id, createEnabled);
                        })
                    )
                    .subscribe(() => {
                        this.userService.signOut(true).pipe(first()).subscribe();
                        if (tenant.settings.signupConfirmationRedirect) {
                            window.location.href = tenant.settings.signupConfirmationRedirect;
                        } else {
                            this.noTouching = false;
                        }
                    });
                } else {
                    this.bounce(); 
                }
            });
        } else {
            this.bounce();            
        }
    }

    bounce():void {
        this.snackBar.open('Your token has expired, please request a new one.', 'OK');
        this.router.navigate(['/signup']);
    }
}
